var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-mt-4"},[_c('div',{staticClass:"contentSKU"},[_c('ul',[_c('li',[_vm._v(_vm._s(_vm.sku))]),_c('li',[_vm._v("SKU")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }